import { ISeriesApi } from "../Models/lcharts/src/api/iseries-api";
import { TrendDirection, Wave, WaveDirection, WaveDrawer, WaveType } from "./WaveComputer";
import { Time,  BarData } from "../Models/lcharts/src/api/data-consumer";
import { Averages } from "./AveragesComputer";
import { WallAlgo } from "./WallAlgo";
import { IChartApi, LineData,  LineStyle, LineType } from "./lcharts/src/api/create-chart";
import { LineWave, SerieColor } from "./LineSerie";
import { SeriesMarker, SeriesMarkerPosition, SeriesMarkerShape } from "./lcharts/src/model/series-markers";
import { Configs } from "./Configs";
import { DGDrawingServiceGlobal, DrawingService } from "../Services/DrawingService";
import { VertAlign } from './lcharts/src/renderers/watermark-renderer';
import { LoggerService } from "../Services/Logger/Logger";
import { PriceRange } from "./lcharts/src/model/price-range";
import { IPriceLine } from "./lcharts/src/api/iprice-line";
import { BarPrice } from "lightweight-charts";
import { CountsData } from "../Services/dg-hub-client.service";

export class IndicatorDrawers {
  public markers: SeriesMarker<Time>[] = [];
  public markerSerieData: LineData[] = [];
  public markerSerie: ISeriesApi<"Line">;
  public bindedWaveComputer:WaveDrawer;
  public bindedOverlayWaveComputer:WaveDrawer;
  public change: number

  private _targetLineSerie: ISeriesApi<"Line">;
  public get targetLineSerie(): ISeriesApi<"Line"> {
    return this._targetLineSerie;
  }
  public set targetLineSerie(value: ISeriesApi<"Line">) {
    this._targetLineSerie = value;
  }

  private _additionalLineSerie: ISeriesApi<"Line">;
  public get additionalLineSerie(): ISeriesApi<"Line"> {
    return this._additionalLineSerie;
  }
  public set additionalLineSerie(value: ISeriesApi<"Line">) {
    this._additionalLineSerie = value;
  }


  private _chart: IChartApi;
  public get chart(): IChartApi {
    return this._chart;
  }
  public set chart(value: IChartApi) {
    this._chart = value;
  }

  public smaBaseLineData: LineData[] = [];
 public smaBase:number;

  private _wavesAsSource: Wave[];
  public get wavesAsSource(): Wave[] {
    return this._wavesAsSource;
  }
  public set wavesAsSource(value: Wave[]) {
    this._wavesAsSource = value;
  }

  public diff: number;
  public priceLine: IPriceLine;
  constructor(private drawingService:DrawingService) { };

  public range: number[] = [];
  public drawAction(canShow: boolean) 
  {

  }
  public drawSingleSignal(element:CountsData){}
}
